module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/gray_plus-24f5a9d380d0795da9b4330111fc827b.png";